// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","dressesDiv":"Home_dressesDiv__WDni3","makeupDiv":"Home_makeupDiv__On3Ro","logo":"Home_logo__s21Dj"};